// removed by extract-text-webpack-plugin
module.exports = {"container":"helpMenu-module-container-a330a94ceceef986ee81b46f9b287671--","item":"helpMenu-module-item-c116456bb8a2c2da05ab9318c3afe638--"};


//////////////////
// WEBPACK FOOTER
// /src/components/header/helpMenu/helpMenu.module.scss
// module id = 1651
// module chunks = 0